/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const InputFieldWrapper = styled(TextField)({
  "&": {
    width: "100%",
    backgroundColor: "#fff",
  },
  "& .MuiInput-underline:after": {
    borderColor: "#A4A4A4",
    transition: "none",
    outline: "none",
  },
  "& .MuiInputBase-root": {
    padding: 0,
    "& .MuiInputBase-input": {
      padding: "10.5px 14px",
      fontSize: 14,
    },
    "& .MuiInputBase-input::placeholder": {
      fontWeight: 400,
    },
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#A4A4A4",
      borderRadius: 8,
      outline: "none",
    },
    "&:hover fieldset": {
      border: "1px solid #A4A4A4",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #A4A4A4",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#A4A4A4 ",
    },
    "& .MuiSvgIcon-root": {
      marginRight: "5px",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(239, 239, 239, 1.5)",
    },
  },
  "& .MuiInputLabel-root.Mui-error": {
    color: "#A4A4A4",
    borderColor: "#A4A4A4 ",
  },

  // asterisk style in label //
  "& .MuiInputLabel-asterisk": {
    color: "red",
  },

  // disabled Input styles

  "& .MuiInputBase-input.Mui-disabled": {
    "-webkit-text-fill-color": "rgba(0, 0, 0, 0.7)",
    borderRadius: 8,
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.7)",
  },
});

function InputField(props) {
  return <InputFieldWrapper size="small" {...props} />;
}

export default InputField;
